import React from "react";
import { useDimensions } from "../../Util";
import { useNavigate } from "react-router-dom";

const ActCard = ({id,text,image,value,type}) => {

    const {w,h} = useDimensions();
    const navigate = useNavigate();


    const Styles = {
        card:{
            width:w>h?"24%":"32%",
            height:w>h?"33%":"40%",
            background:"#393E46",
            display:"flex",
            justifyContent:"center",
            alignItems:"center",
            flexDirection:"column"
        },
        ltb: {
            fontFamily: "Candal",
            fontSize: w > h ? "clamp(25px,2.5vw,30px)" : "clamp(25px,2.5vh,30px)",
        },ltbw: {
            fontFamily: "Candal",
            fontSize: w > h ? "clamp(25px,2.5vw,30px)" : "clamp(18px,2.15vh,25px)",
        },ltn: {
            fontFamily: "Outfit",
            fontSize: w > h ? "clamp(22px,2.25vw,25px)" : "clamp(22px,2.25vh,25px)",
        }, mtb: {
            fontFamily: "Candal",
            fontSize: w > h ? "clamp(20px,2vw,25px)" : "clamp(13px,1.15vh,25px)",
        },mtn: {
            fontFamily: "Outfit",
            fontSize: w > h ? "clamp(15px,1.15vw,20px)" : "clamp(13px,1.15vh,18px)",
            color:"#BEBEBE"
        },stb: {
            fontFamily: "Candal",
            fontSize: w > h ? "clamp(12px,1.25vw,15px)" : "clamp(12px,1.25vh,15px)"        
        },stn: {
            fontFamily: "Outfit",
            fontSize: w > h ? "clamp(11px,1.15vw,13px)" : "clamp(11px,1.15vh,13px)",
        },xstn: {
            fontFamily: "Outfit",
            fontSize: w > h ? "clamp(12px,1.25vw,15px)" : "clamp(12px,1.25vh,15px)",
        },xltb: {
            fontFamily: "Candal",
            fontSize: w > h ? "clamp(38px,4vw,50px)" : "clamp(38px,4vh,50px)",
        },
        smallImage: {
            width: w > h ? 11 * h : 8 * h,
            height: w > h ? 11 * h : 8 * h,
            cursor:"pointer"
        },
    }

    const handleClick=()=>{
        navigate("/comingsoon")
    }

    return <div style={Styles.card}>
        <img src={`/images/${image}`} style={Styles.smallImage} alt="Description" onClick={handleClick}/>
        <div style={{background:type==="time"?"#00ADB5":"#FF2E63",width:"50%",textAlign:"center",marginTop:"7px"}}>
            <p style={Styles.xstn}>{value}{type==="time"?"Min":"$"}</p>
        </div>
        <p style={{...Styles.mtn,marginTop:"7px"}}>{text}</p>
    </div>
}

export default ActCard;